// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "bootstrap/dist/css/bootstrap.min.css";
import { ThemeProvider } from './theme/ThemeProvider';

const setupViewportUnits = () => {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return () => {};
  }

  const doc = document.documentElement;

  const setViewportHeight = () => {
    const viewport = window.visualViewport;
    const height = viewport ? viewport.height : window.innerHeight;
    doc.style.setProperty("--app-viewport-height", `${height}px`);
  };

  const rafSetViewportHeight = () => {
    if ("requestAnimationFrame" in window) {
      window.requestAnimationFrame(setViewportHeight);
    } else {
      setViewportHeight();
    }
  };

  setViewportHeight();

  const listeners = [];
  const addListener = (target, event) => {
    if (!target || !target.addEventListener) return;
    const handler = rafSetViewportHeight;
    target.addEventListener(event, handler);
    listeners.push(() => target.removeEventListener(event, handler));
  };

  addListener(window, "resize");
  addListener(window, "orientationchange");
  addListener(window, "focus");
  addListener(window, "blur");
  addListener(window, "pageshow");

  if (window.visualViewport) {
    addListener(window.visualViewport, "resize");
    addListener(window.visualViewport, "scroll");
  }

  return () => listeners.forEach((off) => off());
};

if (typeof window !== "undefined") {
  if (window.__appViewportCleanup) {
    window.__appViewportCleanup();
  }
  window.__appViewportCleanup = setupViewportUnits();
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();
